// @flow

import React, { Component } from 'react';
import bemify, { toModifiers } from 'bemify-js';

import Confetti, { type ConfettiItem } from './Confetti';

const bem = bemify('confetti');

function createSingleConfetti() {
  const width = Math.random() * 14;
  const height = width * 0.7;
  const colorIdx = Math.ceil(Math.random() * 4);
  let color = 'pink';
  switch (colorIdx) {
    case 1:
      color = 'yellow';
      break;
    case 2:
      color = 'blue';
      break;
    case 3:
      color = 'green';
      break;
    default:
      color = 'pink';
  }

  return {
    className: `${bem('__item', toModifiers(color))}`,
    width: `${width}px`,
    height: `${height}px`,
    top: `${-Math.random() * 20 - 2.5}%`,
    left: `${Math.random() * 100}%`,
    transform: `rotate(${Math.random() * 360}deg)`,
    position: 'absolute',
    opacity: Math.random() + 0.8,
    transition: undefined,
  };
}

function createConfetti({ numOfPieces }) {
  let confettiPieces = [];

  for (let i = 0; i < numOfPieces; i++) {
    const confetti = createSingleConfetti();
    confettiPieces = [confetti, ...confettiPieces];
  }

  return confettiPieces;
}

type ConfettiStatefulProps = {
  shouldLoop: boolean,
  numOfPieces: number,
};

type ConfettiStatefulState = {
  confettiPieces: Array<ConfettiItem>,
};

class ConfettiStateful extends Component<
  ConfettiStatefulProps,
  ConfettiStatefulState
> {
  dropInterval: IntervalID;
  resetInterval: IntervalID;

  static defaultProps = {
    numOfPieces: 150,
    shouldLoop: true,
  };

  constructor(props: ConfettiStatefulProps) {
    super(props);
    const { numOfPieces } = props;
    const options = { numOfPieces };

    this.state = {
      confettiPieces: createConfetti(options),
    };
  }

  componentDidMount() {
    const { shouldLoop } = this.props;
    setTimeout(this.dropConfetti, 0);

    if (shouldLoop) {
      this.resetInterval = setInterval(this.resetConfetti, 5000);
      setTimeout(() => {
        this.dropInterval = setInterval(this.dropConfetti, 5000);
      }, 0);
    }
  }

  componentWillUnmount() {
    clearInterval(this.dropInterval);
    clearInterval(this.resetInterval);
  }

  dropConfetti = () => {
    const { confettiPieces } = this.state;
    const easingFunc = 'cubic-bezier(.02, .01, .47, 1)';

    const droppedConfetti = confettiPieces.map(confetti => {
      const randomBinaryNum = Math.floor(Math.random() * 2);
      const randomizeLeft =
        randomBinaryNum === 0
          ? `${Number(confetti.left.slice(0, -1)) + Math.random() * 15}%`
          : `${Number(confetti.left.slice(0, -1)) - Math.random() * 15}%`;

      confetti.top = '105%';
      confetti.left = randomizeLeft;
      confetti.transition = `top ${
        Math.random() * 3 + 2
      }s ${easingFunc}, left ${Math.random() * 3 + 2}s ${easingFunc}`;

      return confetti;
    });

    this.setState({ confettiPieces: droppedConfetti });
  };

  resetConfetti = () => {
    const { numOfPieces } = this.props;
    const options = { numOfPieces };
    this.setState({ confettiPieces: createConfetti(options) });
  };

  render() {
    return <Confetti {...this.props} {...this.state} />;
  }
}

export default ConfettiStateful;
